/* eslint-disable react/button-has-type */
import React from "react";
import "./loadingSpinnerPage.scss";
/**
 * Basic link component, it’s designed to edit the href attribute
 */
const LoadingSpinnerPage = (props) => {
  return (

    <div className="page-loading-spinner"><div><div></div><div></div><div></div></div></div>
  );
};

LoadingSpinnerPage.propTypes = {};

LoadingSpinnerPage.defaultProps = {};

export default LoadingSpinnerPage;
